/**
 *
 * @module orderCampaign
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class OrderCampaign
 *
 */
export default class OrderCampaign {

    /**
     *
     * @param {String} campaignCode
     * @param {String} voucherCode
     * @throws {InvalidArgumentException}
     *
     */
    constructor(campaignCode, voucherCode) {

        const errorMessage = {
            ctor: 'OrderCampaign(campaignCode, voucherCode)',
            get campaignCode() {
                return `${this.ctor} campaignCode should be a String`;
            },
            get voucherCode() {
                return `${this.ctor} voucherCode should be a String`;
            }
        };

        nonEmptyString(campaignCode, errorMessage.campaignCode, InvalidArgumentException);
        nonEmptyString(voucherCode, errorMessage.voucherCode, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.campaignCode = campaignCode;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.voucherCode = voucherCode;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/orderCampaign.js